"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConcernsOnlyAmount = getConcernsOnlyAmount;
exports.getConcernsOnlyDiscountAmount = getConcernsOnlyDiscountAmount;
exports.getTotalAlteration = getTotalAlteration;
exports.getTotalRepair = getTotalRepair;
exports.hasConcernsOnly = hasConcernsOnly;
exports.isAlteration = isAlteration;
exports.isRepair = isRepair;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// @ts-check

/** @param { { concernsOnly?: Record<string, boolean> } | import("../entities/types").Discount } discount */
function hasConcernsOnly(discount) {
  if (typeof discount.concernsOnly === 'undefined') return false;
  return Object.values(discount.concernsOnly).filter(function (bool) {
    return bool;
  }).length > 0;
}

/**
 * @param { import("../entities/types").Item } item
 * @return {boolean}
 * */
function isAlteration(item) {
  if (!(item !== null && item !== void 0 && item.id)) return false;
  var pricingVersion = Number(item.id.split('.')[0]);
  if (pricingVersion >= 13) return item.id.includes('-ret') && !item.id.includes('-bro');
  return !item.id.includes('-div') && !item.id.includes('-bro');
}

/**
 * @param { import("../entities/types").Item } item
 * @return {boolean}
 * */
function isRepair(item) {
  if (!(item !== null && item !== void 0 && item.id)) return false;
  var pricingVersion = Number(item.id.split('.')[0]);
  if (pricingVersion >= 13) return (item.id.includes('-rep') || item.id.includes('-cure')) && !item.id.includes('-bro');
  return (item.id.includes('-div') || item.id.includes('-cure')) && !item.id.includes('-bro');
}

/**
 * @param { import("../entities/types").Order } order
 * @return {number}
 * */
function getTotalAlteration(order) {
  var _order$clothes;
  if (!((_order$clothes = order.clothes) !== null && _order$clothes !== void 0 && _order$clothes.length)) return 0;
  return order.clothes.reduce(function (sum, cloth) {
    var _cloth$items;
    if (!((_cloth$items = cloth.items) !== null && _cloth$items !== void 0 && _cloth$items.length)) return sum;
    return sum + cloth.items.reduce(function (sumItems, item) {
      return sumItems + (isAlteration(item) ? (item.price || 0) * (item.quantity || 1) : 0);
    }, 0);
  }, 0);
}

/**
 * @param { import("../entities/types").Order } order
 * @return {number}
 * */
function getTotalRepair(order) {
  var _order$clothes2;
  if (!((_order$clothes2 = order.clothes) !== null && _order$clothes2 !== void 0 && _order$clothes2.length)) return 0;
  return order.clothes.reduce(function (sum, cloth) {
    var _cloth$items2;
    if (!((_cloth$items2 = cloth.items) !== null && _cloth$items2 !== void 0 && _cloth$items2.length)) return sum;
    return sum + cloth.items.reduce(function (sumItems, item) {
      return sumItems + (isRepair(item) ? (item.price || 0) * (item.quantity || 1) : 0);
    }, 0);
  }, 0);
}

/**
 * @param { import("../entities/types").Order } order
 * @param { import("../entities/types").Discount } discount
 * @return {number}
 * */
function getConcernsOnlyAmount(order, discount) {
  if (!discount.concernsOnly) return 0;
  var concernsOnly = discount.concernsOnly;
  var total = 0;
  if (concernsOnly.alteration) total += getTotalAlteration(order);
  if (concernsOnly.repair) total += getTotalRepair(order);
  return total;
}

/**
 * @param { import("../entities/types").Order } order
 * @param { import("../entities/types").Discount } discount
 * @return {number}
 * */
function getConcernsOnlyDiscountAmount(order, discount) {
  var _order$clothes3;
  if (_typeof(discount.concernsOnly) !== 'object') return 0;
  if (!((_order$clothes3 = order.clothes) !== null && _order$clothes3 !== void 0 && _order$clothes3.length)) return 0;
  return order.clothes.reduce(function (sum, cloth) {
    var _cloth$items3;
    if (!((_cloth$items3 = cloth.items) !== null && _cloth$items3 !== void 0 && _cloth$items3.length)) return sum;
    return sum + cloth.items.reduce(function (sumItems, item) {
      var _discount$concernsOnl, _discount$concernsOnl2;
      if ((_discount$concernsOnl = discount.concernsOnly) !== null && _discount$concernsOnl !== void 0 && _discount$concernsOnl.alteration && isAlteration(item)) {
        return sumItems + item.quantity * Math.min(discount.value, item.price || 0);
      }
      if ((_discount$concernsOnl2 = discount.concernsOnly) !== null && _discount$concernsOnl2 !== void 0 && _discount$concernsOnl2.repair && isRepair(item)) {
        return sumItems + item.quantity * Math.min(discount.value, item.price || 0);
      }
      return sumItems;
    }, 0);
  }, 0);
}